import axios from 'axios';

export default {
  getList(_, params) {
    return axios.get('Material/GetList', { params });
  },
  reject(_, idList) {
    return axios.post('Material/Reject', idList);
  },
  approve(_, idList) {
    return axios.post('Material/Approve', idList);
  },
};
